import { ExternalLink } from "lucide-react";

export default function What3WordsLink({ words, className = "" }) {
  if (!words) return null;
  const clean = String(words).replace(/^\/+/, "").trim();
  if (!clean) return null;
  return (
    <a
      href={`https://what3words.com/${encodeURIComponent(clean)}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center gap-1 text-xs font-mono hover:underline ${className}`}
      title="View on what3words"
      data-testid="w3w-link"
    >
      <span className="font-bold" style={{ color: "#E11F26" }}>///</span>
      <span>{clean}</span>
      <ExternalLink size={11} className="text-muted-foreground" />
    </a>
  );
}
